var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2"},[_c('section',[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('tuka.site.name')))])])]),_c('section',{staticClass:"row"},_vm._l((_vm.sidebarContent),function(card){return _c('div',{key:card.name,staticClass:"col col-md-4"},[_c('router-link',{staticClass:"componentpage-link",attrs:{"to":{ 
          name: 'componentpage', 
          params: { 
            componentPage: _vm.urlFormatted(card.name)
          } 
        }}},[_c('img',{attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/sunshine.jpg","height":"200px"}}),_c('h3',[_vm._v(_vm._s(card.name))]),_c('p',[_vm._v(_vm._s(card.description))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }